import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import CodeEditor from "@uiw/react-textarea-code-editor";
import Loading from "../../components/Common/Loading";

function Settings(props) {
  const [isEmpty, setIsEmpty] = useState(false);
  const [logo, setLogo] = useState(null);
  const [darkLogo, setDarkLogo] = useState(null);
  const [favicon, setFavicon] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState(``);
  const [footerCode, setFooterCode] = useState(``);
  const [bottomFooterLinks, setBottomFooterLinks] = useState([
    {
      title: "",
      url: "",
    },
  ]);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get settings
  const getSettings = () => {
    setIsLoading(true);
    apiReq(url.GET_SETTINGS, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("about", res.data.about);
          setValue("email", res.data.email);
          setValue("facebook", res.data.facebook);
          setValue("instagram", res.data.instagram);
          setValue("linkedin", res.data.linkedin);
          setValue("phone", res.data.phone);
          setValue("twitter", res.data.twitter);
          setValue("youtube", res.data.youtube);
          setValue("reddit", res.data.reddit);
          setValue("pinterest", res.data.pinterest);
          setValue("discord", res.data.discord);
          setValue("tumblr", res.data.tumblr);
          setValue("address", res.data.address);
          setCode(res.data.custom_code);
          setBottomFooterLinks(
            res.data.bottom_footer_links.length > 0
              ? res.data.bottom_footer_links
              : [
                  {
                    title: "",
                    url: "",
                  },
                ]
          );
          setFooterCode(res.data.custom_code_footer);
          setLogo(res.data.logo);
          setDarkLogo(res.data.darkLogo);
          setFavicon(res.data.favicon);
          setIsEmpty(false);
        } else {
          setIsEmpty(true);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getSettings();
  }, []);

  // Todo: Settings data save
  const onSubmit = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_SETTINGS,
        {
          logo: logo,
          darkLogo: darkLogo,
          favicon: favicon,
          about: data.about,
          facebook: data.facebook,
          twitter: data.twitter,
          instagram: data.instagram,
          linkedin: data.linkedin,
          youtube: data.youtube,
          phone: data.phone,
          email: data.email,
          address: data.address,
          custom_code: code,
          custom_code_footer: footerCode,
          reddit: data.reddit,
          pinterest: data.pinterest,
          discord: data.discord,
          tumblr: data.tumblr,
          bottom_footer_links: bottomFooterLinks,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_SETTINGS,
        {
          logo: logo,
          darkLogo: darkLogo,
          favicon: favicon,
          about: data.about,
          facebook: data.facebook,
          twitter: data.twitter,
          instagram: data.instagram,
          linkedin: data.linkedin,
          youtube: data.youtube,
          phone: data.phone,
          email: data.email,
          address: data.address,
          custom_code: code,
          custom_code_footer: footerCode,
          reddit: data.reddit,
          pinterest: data.pinterest,
          discord: data.discord,
          tumblr: data.tumblr,
          bottom_footer_links: bottomFooterLinks,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "general",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setLogo(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };
  // handleDarkLogoUpload
  const handleDarkLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setDarkLogo(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };
  // handleFaviconUpload
  const handleFaviconUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setFavicon(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // Todo: Bottom Footer Links
  const handleTitle = (e, index) => {
    const { name, value } = e.target;
    const newBottomFooterLinks = [...bottomFooterLinks];
    newBottomFooterLinks[index][name] = value;
    setBottomFooterLinks(newBottomFooterLinks);
  };

  // Delete handleDeleteLink
  const handleDeleteLink = (index) => {
    const newBottomFooterLinks = [...bottomFooterLinks];
    newBottomFooterLinks.splice(index, 1);
    setBottomFooterLinks(newBottomFooterLinks);
  };

  // handleAddLink
  const handleAddLink = () => {
    const newBottomFooterLinks = [...bottomFooterLinks];
    newBottomFooterLinks.push({
      title: "",
      link: "",
    });
    setBottomFooterLinks(newBottomFooterLinks);
  };

  // console.log("bottomFooterLinks", bottomFooterLinks);

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Settings</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mt-4">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label>Logo (Dark)</label>
                        <div
                          className="dropzone p-4 mb-3"
                          style={{ height: 120, minHeight: 120 }}
                        >
                          {!logo ? (
                            <div
                              className="needsclick"
                              // {...getRootProps()}
                            >
                              {/* <input /> */}
                              <div className="mb-3">
                                <i className="ri-image-line display-4 text-muted"></i>
                              </div>
                              <h5 className="opacity-40">Set Logo</h5>
                              <input
                                type="file"
                                className="image_upload_input"
                                onChange={(e) => handleLogoUpload(e)}
                              />
                            </div>
                          ) : (
                            <div className="filled_image">
                              <img
                                src={logo}
                                alt="image"
                                className="img-fluid"
                              />
                              <div
                                className="remove_image"
                                onClick={() => setLogo(null)}
                              >
                                <i className="mdi mdi-close-thick"></i>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label>Logo (White)</label>
                        <div
                          className="dropzone p-4 mb-3"
                          style={{
                            height: 120,
                            minHeight: 120,
                            backgroundColor: "#333333",
                          }}
                        >
                          {!darkLogo ? (
                            <div
                              className="needsclick"
                              // {...getRootProps()}
                            >
                              {/* <input /> */}
                              <div className="mb-3">
                                <i className="ri-image-line display-4 text-muted"></i>
                              </div>
                              <h5
                                className="opacity-40"
                                style={{ color: "#ffffff" }}
                              >
                                Set Footer Logo
                              </h5>
                              <input
                                type="file"
                                className="image_upload_input"
                                onChange={(e) => handleDarkLogoUpload(e)}
                              />
                            </div>
                          ) : (
                            <div className="filled_image">
                              <img
                                src={darkLogo}
                                alt="image"
                                className="img-fluid"
                              />
                              <div
                                className="remove_image"
                                onClick={() => setDarkLogo(null)}
                              >
                                <i className="mdi mdi-close-thick"></i>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label>Favicon</label>
                        <div
                          className="dropzone p-4 mb-3"
                          style={{ height: 120, minHeight: 120 }}
                        >
                          {!favicon ? (
                            <div
                              className="needsclick"
                              // {...getRootProps()}
                            >
                              {/* <input /> */}
                              <div className="mb-3">
                                <i className="ri-image-line display-4 text-muted"></i>
                              </div>
                              <h5
                                className="opacity-40"
                                style={{ color: "#ffffff" }}
                              >
                                Favicon
                              </h5>
                              <input
                                type="file"
                                className="image_upload_input"
                                onChange={(e) => handleFaviconUpload(e)}
                              />
                            </div>
                          ) : (
                            <div className="filled_image">
                              <img
                                src={favicon}
                                alt="image"
                                className="img-fluid"
                              />
                              <div
                                className="remove_image"
                                onClick={() => setFavicon(null)}
                              >
                                <i className="mdi mdi-close-thick"></i>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label>About</label>
                    <textarea
                      type="text"
                      className="form-control"
                      {...register("about", { required: true })}
                      placeholder="Enter about text"
                    />
                    {errors.about && (
                      <span className="text-danger">About is required</span>
                    )}
                  </div>
                  <h4>Information:</h4>
                  <hr />
                  <div className="mb-3">
                    <label>Phone</label>
                    <input
                      type="tel"
                      className="form-control"
                      {...register("phone", { required: false })}
                      placeholder="Enter phone"
                    />
                  </div>
                  <div className="mb-3">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      {...register("email", { required: false })}
                      placeholder="Enter email"
                    />
                  </div>
                  <div className="mb-3">
                    <label>Address</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("address", { required: false })}
                      placeholder="Enter address"
                    />
                  </div>
                  <h4>Social links:</h4>
                  <hr />
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-facebook-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#4267B2",
                        }}
                      ></i>
                      Facebook
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("facebook", { required: false })}
                      placeholder="Enter facebook link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-twitter-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#1DA1F2",
                        }}
                      ></i>
                      Twitter
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("twitter", { required: false })}
                      placeholder="Enter twitter link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-instagram-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#fb3958",
                        }}
                      ></i>
                      Instagram
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("instagram", { required: false })}
                      placeholder="Enter instagram link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-linkedin-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#0077b5",
                        }}
                      ></i>
                      Linkedin
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("linkedin", { required: false })}
                      placeholder="Enter linkedin link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-youtube-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#FF0000",
                        }}
                      ></i>{" "}
                      Youtube
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("youtube", { required: false })}
                      placeholder="Enter youtube link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-reddit-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#FF4500",
                        }}
                      ></i>{" "}
                      Reddit
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("reddit", { required: false })}
                      placeholder="Enter reddit link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-pinterest-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#E60023",
                        }}
                      ></i>{" "}
                      Pinterest
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("pinterest", { required: false })}
                      placeholder="Enter pinterest link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-discord-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#7289DA",
                        }}
                      ></i>{" "}
                      Discord
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("discord", { required: false })}
                      placeholder="Enter discord link"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="d-flex align-items-center">
                      <i
                        className="ri-tumblr-fill"
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                          color: "#35465C",
                        }}
                      ></i>{" "}
                      Tumblr
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("tumblr", { required: false })}
                      placeholder="Enter tumblr link"
                    />
                  </div>
                </div>
                <h4 className="mt-4 mb-0">Footer Bottom Area:</h4>
                <hr />
                {bottomFooterLinks.map((item, index) => {
                  return (
                    <div className="mb-3 row" key={`fba${index + 2}`}>
                      <div className="col-md-11">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              placeholder="Enter title"
                              value={item.title}
                              onChange={(e) => handleTitle(e, index)}
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Link</label>
                            <input
                              type="text"
                              className="form-control"
                              name="url"
                              placeholder="/..."
                              value={item.url}
                              onChange={(e) => handleTitle(e, index)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <label>&nbsp;</label>
                        <button
                          className="btn btn-danger w-100"
                          type="type"
                          onClick={() => handleDeleteLink(index)}
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </div>
                  );
                })}
                <div className="mb-3 d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => handleAddLink()}
                  >
                    Add new item
                  </button>
                </div>
                <hr />
                <h4 className="mt-4 mb-0">Code For tawk.to chatbot</h4>
                {/* <small>
                  <code>{`Add code at the end of the <head> tag:`}</code>
                </small> */}

                <CodeEditor
                  value={code}
                  language="js"
                  placeholder="Please enter JS code."
                  onChange={(evn) => {
                    return setCode(evn.target.value);
                  }}
                  padding={15}
                  style={{
                    fontSize: 12,
                    minHeight: 250,
                    backgroundColor: "#f5f5f5",
                    fontFamily:
                      "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                  }}
                />

                <h4 className="mt-4 mb-0">Custom Code</h4>
                {/* <small>
                  <code>{`Add code before </body> tag:`}</code>
                </small> */}

                <CodeEditor
                  value={footerCode}
                  language="js"
                  placeholder="Please enter JS code."
                  onChange={(evn) => {
                    return setFooterCode(evn.target.value);
                  }}
                  padding={15}
                  style={{
                    fontSize: 12,
                    minHeight: 250,
                    backgroundColor: "#f5f5f5",
                    fontFamily:
                      "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                  }}
                />

                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Settings;
